import script from "./LegendUI.vue?vue&type=script&setup=true&lang=js"
export * from "./LegendUI.vue?vue&type=script&setup=true&lang=js"

import "./LegendUI.vue?vue&type=style&index=0&id=aa2857b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa2857b2"]])

export default __exports__